import {LeadEventApiDto, LeadExternalCallRegisteredEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");

export default class LeadExternalCallRegisteredEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data external call registered event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadExternalCallRegisteredEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadExternalCallRegisteredEvent {
		const data = LeadExternalCallRegisteredEventData.fromJson(json.data as LeadExternalCallRegisteredEventDataApiDto);

		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadExternalCallRegisteredEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.ExternalCallRegistered,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.Phone;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityAdditionalMessages(): string[] {
		return [this.data.conversationContent];
	}

	getActivityType(): string {
		return "LEAD PHONE CALL";
	}

	getActivityMessage(): string {
		return `Lead external call registered`;
	}
}

export class LeadExternalCallRegisteredEventData {
	constructor(public readonly conversationContent: string) {}

	public static fromJson(json: LeadExternalCallRegisteredEventDataApiDto): LeadExternalCallRegisteredEventData {
		return new LeadExternalCallRegisteredEventData(json.conversationContent);
	}
}
